import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListCrewTitle = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['bold']};
  font-size: ${32 * Screen.widthRatio}px;
  margin-right: ${10 * Screen.widthRatio}px;
`;

export default ChannelListCrewTitle;
